import { apiType } from "./apiType";
import { applicantHistoryRequests } from "./applicantHistoryRequests";
import { applicantsRequests } from "./applicantsRequests";
import { documentsRequests } from "./documentsRequests";
import { IApplicantUpdatePayload } from "@/src/types/applicant";

export interface IStudentsListParams {
  query: string;
  office?: "MALTA" | "UKRAINE" | "POLAND" | "ALL";
  limit?: number;
  offset?: number;
}

export interface IStudentUpdatePayload {
  fullname?: string;
  fullname_nat?: string;
  email?: string;
  phone?: string;
  course?: string;
  language?: string;
  country?: string;
  nationality?: string;
  residence?: string;
  contact_person?: string;
  birth_date?: string;
  address?: string;
  passport_number?: string;
  passport_issued?: string;
  valid_passport?: string;
  student_status?: string;
}

export interface IStudentHistoryCreatePayload {
  student_id: number;
  text: string;
}

export type StudentDocumentFileType = "passport" | "certificate" | "education" | "another";

export const studentsRequests = {
  getList: async ({ query, office = "ALL", limit = 50, offset = 0 }: IStudentsListParams) => {
    try {
      return await apiType.main.get(`/student/list`, {
        query,
        office,
        limit,
        offset,
      });
    } catch (error) {
      console.log("This is getList error:", error);
      return null;
    }
  },
  getUpdate: async (applicantId: number, data: IStudentUpdatePayload) =>
    applicantsRequests.update(applicantId, data as IApplicantUpdatePayload),
  // getHistory: async (studentId: number) => {
  //   try {
  //     return await apiType.main.get(`/student/history`, {
  //       student_id: studentId,
  //     });
  //   } catch (error) {
  //     console.log("This is getHistory error:", error);
  //     return null;
  //   }
  // },
  createHistory: async (data: IStudentHistoryCreatePayload) =>
    applicantHistoryRequests.create({
      text: data.text,
      applicant_id: data.student_id,
    }),
  uploadUniversityDocuments: async (applicantId: number, file: File) =>
    documentsRequests.uploadUniversityDocument(applicantId, file),
  uploadStudentDocument: async (applicantId: number, fileType: StudentDocumentFileType, file: File) =>
    documentsRequests.uploadApplicantDocument(applicantId, fileType, file),
};
